export const PersonSelect = {
  DEFAULT: {
    EMPTY: "Нікого не знайдено",
    LOADING: "Шукаю...",
    PLACEHOLDER: "Знайти особу...",
  },
};
